function WhatIDo() {
    return(
        <div className="expert" id="what-i-do">
            <div className="container row">
                <div className="expert__col">
                    <h3>What I Do?</h3>
                    <p>Welcome to my world, where I bring ideas to life and turn concepts into reality. My passion lies in creating seamless digital experiences that leave a lasting impact.
                    Here's a glimpse into what I do:</p>
                    <a href="#"><button className="btn__normal">Say Hello</button></a>
                </div>
                <div className="expert__col">
                    <div className="expert__col--secondary">
                        <h4>Web Development</h4>
                        <p>With a keen eye for detail and a love for coding, I specialize in crafting responsive and user-friendly websites. From dynamic landing pages to robust web applications, I bring functionality and aesthetics together.</p>
                    </div>
                    <div className="expert__col--secondary">
                        <h4>UI/UX</h4>
                        <p>Design is not just about how it looks but also how it feels. I focus on creating intuitive and visually appealing user interfaces, ensuring a delightful user experience. Let's make your digital presence unforgettable.</p>
                    </div>
                    <div className="expert__col--secondary">
                        <h4>Hosting</h4>
                        <p>Take your online presence to the next level with reliable and scalable hosting solutions powered by Microsoft Azure. I offer seamless integration and deployment, ensuring your website or application is always accessible and performs optimally.</p>

                    </div>
                    <div className="expert__col--secondary">
                        <h4>API Integration</h4>
                        <p>Connect and streamline your digital systems with seamless API integrations. I specialize in integrating third-party APIs and creating custom API solutions to enhance the functionality and efficiency of your applications.</p>

                    </div>

                </div>
            </div>
        </div>
    );
}
export default WhatIDo;